import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AddSpacesPipeModule } from 'src/app/pipes/split-enum-strings/add-spaces-pipe.module';
import { AccountExtensionsComponent } from './account-extensions/containers/account-extensions.component';
import {
   ExtensionInfoComponent,
   FormatExtensionPipe,
} from './account-extensions/extension-summary/extension-info.component';
import { AccountLocationsComponent } from './account-locations/containers/account-locations.component';
import { LocationInfoComponent } from './account-locations/location-summary/location-info.component';
import { AccountPhoneNumbersComponent } from './account-phone-numbers/containers/account-phone-numbers.component';
import { PhoneNumberInfoComponent } from './account-phone-numbers/location-summary/phone-number-info.component';
import { AddAccountAutoAttendantKeysComponent } from './add-account-auto-attendant-keys/containers/add-account-auto-attendant-keys.component';
import { AddAccountAutoAttendantKeysViewComponent } from './add-account-auto-attendant-keys/views/add-account-auto-attendant-keys-view.component';
import { AddAccountExtensionComponent } from './add-account-extension/containers/add-account-extension.component';
import { AddAccountExtensionViewComponent } from './add-account-extension/views/add-account-extension-view.component';
import { AddAccountLocationComponent } from './add-account-location/containers/add-account-locations.component';
import { AddAccountLocationViewComponent } from './add-account-location/views/add-account-location-view.component';
import { AddAccountPhoneNumberComponent } from './add-account-phone-numbers/containers/add-account-phone-numbers.component';
import { AddAccountPhoneNumbersViewComponent } from './add-account-phone-numbers/views/add-account-phone-numbers-view.component';
import { AddAccountComponent } from './containers/add-account.component';
import { AddAccountEffects } from './state/add-account.effects';
import * as fromAddAccount from './state/add-account.reducer';
import { AddAccountViewComponent } from './views/add-account-view.component';

@NgModule({
   declarations: [
      AddAccountComponent,
      AddAccountViewComponent,
      AddAccountExtensionComponent,
      AddAccountExtensionViewComponent,
      AddAccountPhoneNumberComponent,
      AddAccountPhoneNumbersViewComponent,
      AddAccountLocationComponent,
      AddAccountLocationViewComponent,
      AccountLocationsComponent,
      AccountExtensionsComponent,
      ExtensionInfoComponent,
      AddAccountAutoAttendantKeysComponent,
      AddAccountAutoAttendantKeysViewComponent,
      FormatExtensionPipe,
      PhoneNumberInfoComponent,
      LocationInfoComponent,
      AccountPhoneNumbersComponent,
   ],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatButtonModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      MatMenuModule,
      MatRadioModule,
      MatSlideToggleModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      EntitySelectModule,
      LcsDatepickerModule,
      MatCardModule,
      LcsResponsiveTableModule,
      AddSpacesPipeModule,
      FormatPhoneNumbersPipeModule,
      LcsSingleSelectModule,
      LocationModule,
      StoreModule.forFeature(fromAddAccount.addAccountFeatureKey, fromAddAccount.reducer),
      EffectsModule.forFeature([AddAccountEffects]),
   ],
})
export class AddAccountModule {}
